import React, { useState } from "react";
import ortapedikLG from "../assets/images/ortapedikLG.png";
import dizlikLG from "../assets/images/dizlikCatLG.png";
import sliconLG from "../assets/images/sliconCatLG.png";
import bandajLG from "../assets/images/bandajCatLG.png";
import left from "../assets/images/left.png";
import right from "../assets/images/right.png";
import ortapedikSM from "../assets/images/ortapedikCatSM.png";
import dizlikSM from "../assets/images/dizlikSM.png";
import sliconSM from "../assets/images/sliconSM.png";
import bandajSM from "../assets/images/bandajSM.png";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";

interface ICategory {
  name: string;
  image: any;
  lgImage: any;
  id: number;
}


const MostProductCategories: React.FC = () => {
  const { t } = useLanguage();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate();

  const categories: ICategory[] = [
    {
      id: 4,
      name: t('mostProductCategories','name1'),
      image: ortapedikSM,
      lgImage: ortapedikLG,
    },
    {
      id: 2,
      name: t('mostProductCategories','name2'),
      image: dizlikSM,
      lgImage: dizlikLG,
    },
    {
      id: 8,
      name: t('mostProductCategories','name3'),
      image: bandajSM,
      lgImage: bandajLG,
    },
    {
      id: 86,
      name: t('mostProductCategories','name4'),
      image: sliconSM,
      lgImage: sliconLG,
    },
  ];

  const handleNavigate = (id: number, subCatName: string) => {
    if(id == 86)  {
      return navigate(`/product-categories/${id}?subCatName=${subCatName}&isMost=${false}`);  
    }else {

      return navigate(`/product-categories/${id}?subCatName=${subCatName}&isMost=${true}`);
    }
  };

  const nextSlide = () => {
    setSelectedIndex((prev) => (prev === categories.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setSelectedIndex((prev) => (prev === 0 ? categories.length - 1 : prev - 1));
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="flex flex-col gap-y-5 mb-5 mt-14 justify-center items-center px-2 sm:px-20 xl:px-0"
    >
      <motion.h2
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.1 }}
        className="font-semibold text-xl md:text-2xl lg:text-3xl text-[#302842] font-poppins"
      >
        {t('mostProductCategories', 'title')}
      </motion.h2>

      <div className=" grid grid-cols-2 md:flex w-full xl:w-8/12 justify-center items-center gap-4 mt-8">
        {categories.map((item, i) => (
          <motion.div
            key={i}
            className={`transition-all duration-300 cursor-pointer rounded-lg relative ${
              i === selectedIndex ? "flex-[1.5] opacity-100" : "flex-1 opacity-70"
            }`} 
            onClick={() => {
              setSelectedIndex(i);
              if (i === selectedIndex) {
                handleNavigate(item.id, item.name);
              }
            }}
            whileHover={{ scale: i === selectedIndex ? 1.01 : 1 }}
          >
            <motion.img
              src={i === selectedIndex ? item.lgImage : item.image}
              alt={item.name}
              className="w-full h-full object-cover rounded-lg shadow-lg min-h-[500px]"
              initial={false}
              animate={{ scale: i === selectedIndex ? 1 : 0.95 }}
              transition={{ duration: 0.2 }}
            />
            {i === selectedIndex && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                className="absolute bottom-4 left-4 p-2 bg-[#F5F5F5] rounded-lg shadow-lg hidden md:flex"
              >
                <p className="text-[#141C3A] font-normal lg:font-bold text-lg lg:text-xl">
                  {item.name}
                </p>
              </motion.div>
            )}
          </motion.div>
        ))}
      </div>

      <div className="flex justify-between w-full xl:w-7/12 mt-4 items-center flex-col sm:flex-row gap-y-3 md:gap-y-0">
        <div className="flex gap-x-0 sm:gap-x-4">
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="cursor-pointer"
            onClick={prevSlide}
          >
            <img src={left} alt="left" loading="lazy" className="w-1/2 sm:w-full" />
          </motion.div>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="cursor-pointer"
            onClick={nextSlide}
          >
            <img src={right} alt="right" loading="lazy" className="w-1/2 sm:w-full" />
          </motion.div>
        </div>
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <p
            onClick={() => handleNavigate(categories[selectedIndex].id, categories[selectedIndex].name)}
            className="text-[#777497] text-xs lg:text-sm select-none text-center cursor-pointer hover:text-[#FFC633] transition-colors"
          >
            {t('mostProductCategories', 'button')} {categories[selectedIndex].name}
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default MostProductCategories;
